import {
  SearchSearchProductAttribute,
  SearchSearchProductsResponse,
} from '@winelivery-org/wl-client-sdk-js/src/models/search/product';
import { upperFirst } from 'lodash';
import { useTranslations } from 'next-intl';
import { ChevronRight as IconChevronRight } from '../../../../../../../components/icons';
import { Link } from '../../../../../../../navigation';

interface Props {
  suggestions: SearchSearchProductsResponse;
  onClick?: () => void;
}

export default function Categories({ suggestions, onClick }: Props) {
  const t = useTranslations('shop');

  function handleClick() {
    if (onClick) {
      onClick();
    }
  }

  function getLink(attribute: SearchSearchProductAttribute) {
    return attribute.parent
      ? {
          pathname: '/shop',
          query: {
            category: attribute.parent.slug,
            subcategory: attribute.slug,
          },
        }
      : { pathname: '/shop', query: { category: attribute.slug } };
  }

  if (
    suggestions.categories.items.length === 0 &&
    suggestions.subcategories.items.length === 0
  ) {
    return null;
  }

  const items = [
    ...suggestions.categories.items,
    ...suggestions.subcategories.items,
  ].sort((a, b) => {
    const first = a.parent ? `${a.parent.name} - ${a.name}` : a.name;
    const second = b.parent ? `${b.parent.name} - ${b.name}` : b.name;
    return first.localeCompare(second);
  });

  return (
    <div className="">
      <h5 className="tw-text-lg tw-text-greyscale-title tw-font-bold tw-tracking-tighter tw-m-0">
        {t('search.categories')}
      </h5>
      <ul className="tw-divide-y tw-divide-greyscale-separator tw-m-0 tw-p-0">
        {items.map((attribute) => (
          <li className="tw--mx-4" key={attribute.id}>
            <Link<any>
              href={getLink(attribute)}
              onClick={handleClick}
              className="tw-cursor-pointer hover:tw-bg-greyscale-background tw-flex tw-items-center tw-py-2 tw-px-4 tw-text-greyscale-body tw-no-underline hover:tw-text-greyscale-body"
            >
              <span className="tw-flex-1 tw-text-base tw-text-font-medium tw-tracking-tight tw-leading-5 tw-truncate">
                {attribute.parent
                  ? `${upperFirst(attribute.parent.name)} - ${upperFirst(
                      attribute.name,
                    )}`
                  : upperFirst(attribute.name)}
              </span>
              <IconChevronRight className="tw-shrink-0 tw-h-5" />
            </Link>
          </li>
        ))}
      </ul>
    </div>
  );
}
